export default __webpack_public_path__ + "static/media/qr_code.6431101f.png";